import { useEffect } from 'react';

import useLogout from 'hooks/useLogout';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const LogoutPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { isLoggingOut, logout } = useLogout();

    useEffect(() => {
        if (!isLoggingOut) {
            logout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggingOut]);

    return <p data-testid={testId}>Logout - Loading...</p>;
};

export default LogoutPage;
